import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import H3 from '@sdk/components/ui/typography/H3';
import Href from '@sdk/components/ui/Href';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import EmptyWagesStateSvg from '@web/assets/svg/Misc/empty-wages-state.svg';
import { EmptyModalContainer } from '@web/onboarding/Checklist/DefineWagesModal/defineWagesModal.styles';
import {
  CenterContentRow,
  ModalContent,
} from '@web/onboarding/Checklist/components/modalBase.style';

type Props = {
  onAddEmployees: () => void;
};

const NoEmployeesNoPositionsContent = ({ onAddEmployees }: Props): JSX.Element => (
  <EmptyModalContainer>
    <CenterContentRow pTop={20} pBottom={20}>
      <H3>{gettext('Add Wages')}</H3>
    </CenterContentRow>

    <ModalContent>
      <Column alignItems="center">
        <Column mTop={20} mLeft={40}>
          <EmptyWagesStateSvg />
        </Column>
        <Column mTop={20}>
          <Text14 themeColor={ThemeColorType.gray} semiBold>
            {gettext('Looks like you have no employees yet.')}
          </Text14>
        </Column>
        <Text14 themeColor={ThemeColorType.gray} semiBold>
          {gettext('Add employees first, to be able to specify their wages.')}
        </Text14>
        <Column mTop={10}>
          <Href onClick={onAddEmployees} themeColor={ThemeColorType.primary} fontSize={14} semiBold>
            {gettext('Add employees')}
          </Href>
        </Column>
      </Column>
    </ModalContent>
  </EmptyModalContainer>
);

export default NoEmployeesNoPositionsContent;
